<template lang="pug">
  SspLayout(area="core")
    .row.code-configuration
      .col-md-12
        .panel.panel-default
          .text-center.loading(v-if="loading")
            i.fa.fa-spinner.fa-pulse.fa-spin.fa-2x
          .panel-body(v-if="codeConfig")
            .row
              label.col-sm-2 Name
              .col-sm-4 {{codeConfig.name}}
              label.col-sm-2 Alias
              .col-sm-4 {{ codeConfig.alias }}

            .row
              label.col-sm-2 Type
              .col-sm-4 {{codeConfig.type}}
              label.col-sm-2 Alphabet
              .col-sm-4 {{codeConfig.alphabet}}

            .row
              label.col-sm-2 Default Length
              .col-sm-4 {{codeConfig.defaultCodeLength}}
              label.col-sm-2 Min Length
              .col-sm-4 {{codeConfig.minCodeLength}}

            .row
              label.col-sm-2 Max Length
              .col-sm-4 {{codeConfig.maxCodeLength}}
              label.col-sm-2 Reference Length
              .col-sm-4 {{codeConfig.referenceLength}}

            .row
              label.col-sm-2 Counter Length
              .col-sm-4 {{codeConfig.counterLength}}
              label.col-sm-2 Security Length
              .col-sm-4 {{codeConfig.securityLength}}

            hr
            .row
              label.col-sm-2 Max Orders
              .col-sm-4 {{ maxOrders | number }}
              label.col-sm-2 Max Codes
              .col-sm-4 {{ maxCodes | number}}
            .row
              label.col-sm-2 Code Per Order
              .col-sm-4 {{ codesPerOrder | number }}

</template>

<script>
import Core from '@/service/apis/Core'
import { numberFilter } from '@/filters/filters'

export default {
  data: () => ({
    mo: 0,
    cpo: 0,
    loading: false,
    codeConfig: null
  }),
  created() {
    this.loading = true
    Core.getCodeConfig(this.codeConfigId)
      .then((resp) => {
        this.codeConfig = resp.data
      })
      .catch((e) => {
        this.$emit('error', e)
      })
      .then(() => {
        this.loading = false
      })
  },
  computed: {
    codeConfigId() {
      return parseInt(this.$route.params.id, 10)
    },
    maxOrders() {
      return this.codeConfig.alphabet ? parseInt(this.codeConfig.alphabet.length ** this.codeConfig.referenceLength, 10) : 0
    },
    maxCodes() {
      return this.codesPerOrder && this.maxOrders ? parseInt(this.codesPerOrder * this.maxOrders, 10) : 0
    },
    codesPerOrder() {
      return this.codeConfig.alphabet ? parseInt(this.codeConfig.alphabet.length ** this.codeConfig.counterLength, 10) : 0
    },
  },
  filters: {
    number: numberFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/codeconfiguration/CodeConfiguration.vue